import Swiper from 'swiper';

/**
 * Represents a collection of swiper containers.
 * @type {NodeList}
 */
const swiperVideoTestimonials = document.querySelectorAll('.swiper-container.video-testimonials-swiper');

// Loop through each selector and initialize Swiper
swiperVideoTestimonials.forEach(selector => {
  const swiper = new Swiper(selector, {
    speed: 400,
    spaceBetween: 0,
    slidesPerView: 1,
    loop: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
  });
});



/**
 * Represents a collection of swiper containers.
 * @type {NodeList}
 */
const swiperGallerySliderSimple = document.querySelectorAll('.swiper-container.gallery-slider-simple');

// Loop through each selector and initialize Swiper
swiperGallerySliderSimple.forEach(selector => {
  const swiper = new Swiper(selector, {
    speed: 400,
    spaceBetween: 32,
    slidesPerView: 1,
    loop: false,
    noSwipingClass: 'vjs-default-dimensions',
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      speed: 2000,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        loop: true,
      },
    },
  });
});


/**
 * Represents a collection of swiper containers.
 * @type {NodeList}
 */
const swiperLogosSliderTop = document.querySelectorAll('.swiper-container.logos-swiper-top');

// Loop through each selector and initialize Swiper
swiperLogosSliderTop.forEach(selector => {
  const swiper = new Swiper(selector, {
    speed: 400,
    spaceBetween: 0,
    slidesPerView: 4,
    loop: true,
    spaceBetween: 30,
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    freeMode: true,
    speed: 2000,
    freeModeMomentum: false,
    breakpoints: {
      1400: {
        slidesPerView: 15,
        loop: true,
      },
      1200: {
        slidesPerView: 12,
        loop: true,
      },
      992: {
        slidesPerView: 10,
        loop: true,
      },
      768: {
        slidesPerView: 8,
        loop: true,
      },
      576: {
        slidesPerView: 4,
        loop: true,
      },
    },
  });
});

/**
 * Represents a collection of swiper containers.
 * @type {NodeList}
 */
const swiperLogosSliderBottom = document.querySelectorAll('.swiper-container.logos-swiper-bottom');

// Loop through each selector and initialize Swiper
swiperLogosSliderBottom.forEach(selector => {
  const swiper = new Swiper(selector, {
    speed: 400,
    spaceBetween: 0,
    slidesPerView: 4,
    loop: true,
    spaceBetween: 30,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
      reverseDirection: true
    },
    freeMode: true,
    speed: 2000,
    freeModeMomentum: false,
    breakpoints: {
      1400: {
        slidesPerView: 15,
        loop: true,
      },
      1200: {
        slidesPerView: 12,
        loop: true,
      },
      992: {
        slidesPerView: 10,
        loop: true,
      },
      768: {
        slidesPerView: 8,
        loop: true,
      },
      576: {
        slidesPerView: 4,
        loop: true,
      },
    },
  });
});